/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Color_BlueInputs */

const en_orders_review_color_blue = /** @type {(inputs: Orders_Review_Color_BlueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blue`)
};

const es_orders_review_color_blue = /** @type {(inputs: Orders_Review_Color_BlueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azul`)
};

/**
* | output |
* | --- |
* | "Blue" |
*
* @param {Orders_Review_Color_BlueInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_color_blue = /** @type {((inputs?: Orders_Review_Color_BlueInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Color_BlueInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_color_blue(inputs)
	return es_orders_review_color_blue(inputs)
});